export const ZWIFT_POSTFIX = ' zwift screen';
